import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useStore } from '../../../hooks';
import { DocumentSigningContent } from './documentSigningContent';
import { SignatureFieldHandle } from '@roc/ui';
import { WireAuthorizationState } from '../../../types';

export const DocumentSigning = observer(() => {
  const { wireAuthorizationStore, globalStore } = useStore();
  const formValues = wireAuthorizationStore.getFormValues();
  const signatureRef = useRef<SignatureFieldHandle>(null);

  useEffect(() => {
    wireAuthorizationStore.setLoading(false);
  }, []);

  const handleSubmit = () => {
    if (signatureRef.current.isSigned()) {
      const signatureURL = signatureRef.current.getSignature();
      wireAuthorizationStore.confirmSignature(signatureURL,
        {
          accountName: formValues.accountName,
          routingNumber: formValues.routingNumber,
          accountNumber: formValues.accountNumber,
          bankName: formValues.bankName,
          streetName: formValues.streetName,
          city: formValues.city,
          zipCode: formValues.zipCode,
          state: formValues.state,
          ffcAccountName: formValues.fccAccountName,
          ffcRoutingNumber: formValues.fccRoutingNumber,
          ffcAccountNumber: formValues.fccAccountNumber,
          ffcBankName: formValues.fccBankName,
          ffcStreetName: formValues.fccStreetName,
          fccCity: formValues.fccCity,
          fccZipCode: formValues.fccZipCode,
          fccState: formValues.fccState
        }
      );
      wireAuthorizationStore.setWireAuthorizationState(WireAuthorizationState.DONE);
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please sign the document before submitting it',
      });
    }
  };

  return (
    <>
      <DocumentSigningContent
        signatureRef={signatureRef}
        handleSubmit={handleSubmit}
      />
    </>
  );
});
